module.exports = __webpack_public_path__ + "img/loading.40fb5cfe.gif";